import React from "react";
import { css } from "glamor";
import { spacing, colors, styles } from "../library/theme";
import Link from "../library/Link";

const container = css({
  width: "100%",
  display: "flex",
  alignItems: "center",
  gap: spacing.m,
  paddingTop: spacing.m,
  paddingBottom: spacing.m,
  border: "none",
  "@media (max-width: 768px)": {
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    gap: spacing.s,
  },
});
const greetingWrapper = css({
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "space-between",
  gap: spacing.s,
  width: "100%",
});
const greetingClass = css({
  flex: 1,
  minWidth: 250
});
const avatarClass = css({
  height: 60,
  width: 60,
  borderRadius: "50%",
  objectFit: "cover",
  flexShrink: 0,
  "@media (max-width: 768px)": {
    height: 80,
    width: 80,
  },
});
const titleClass = css(styles.alternativeFontFamily, {
  color: colors.secondary,
  fontSize: "24px",
  fontWeight: "bold",
  lineHeight: "normal",
});
const textWrapper = css({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  gap: spacing.s,
  "@media (max-width: 768px)": {
    marginTop: spacing.xs,
    justifyContent: "center",
  }
});
const jobTitleClass = css({
  color: colors.grey,
  lineHeight: "normal",
});

const pendingPaymentContainer = css({
  lineHeight: 'normal',
  backgroundColor: 'rgba(255, 0, 0, 0.1)',
  border: '1px solid rgba(255, 0, 0, 0.8)',
  color: 'rgba(255, 0, 0, 0.8)',
  padding: `${spacing.xs} ${spacing.s}`,
  borderRadius: '5px',
  fontSize: '14px',
  textAlign: 'center',
  maxWidth: 'fit-content',
  maxHeight: 'fit-content',
  marginBottom: 'auto'
});
const pendingPaymentLink = {
  color: 'rgba(255, 0, 0, 0.8)',
  fontWeight: 'bold',
  textDecoration: 'underline',
  ':hover': {
    textDecoration: 'none',
  },
};

const PendingPaymentAlert = ({ subscription }) => {
  return (
    <div className={pendingPaymentContainer}>
      Há uma pendência em sua assinatura.{' '}
      <Link to={`/finance/subscriptions/${subscription.id}`} style={pendingPaymentLink}>
        Clique aqui
      </Link>{' '}
      para verificar.
    </div>
  );
};

export default function Greeting({ user, subscription }) {
  return user ? (
    <div className={container}>
      <img className={avatarClass} src={user?.avatarUrl} />

      <div className={greetingWrapper}>
        <div className={greetingClass}>
          <p className={titleClass}>{`Bem-vindo(a)${user?.signInCount > 1 ? " de volta" : ""
            }, ${user?.firstName}!`}</p>
          <div className={textWrapper}>
            {user?.jobTitle && <p className={jobTitleClass}>{user?.jobTitle}</p>}
            <Link to="/greetings">{`${user?.jobTitle ? "Editar" : "Cadastrar"
              } cargo e interesses`}</Link>
          </div>
        </div>

        {subscription && <PendingPaymentAlert subscription={subscription} />}
      </div>
    </div>
  ) : null;
}
